import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const ServiceThree = () => {
  let settings = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className="service-area-2 space-bottom">
      <div className="container">
        <div className="row align-items-end">
          <div className="col-lg-5">
            <div className="title-area">
              <span className="sub-title">
                <img src="assets/img/icon/title_left.svg" alt="Ícone de Destaque Rocvel" />
                Nossos Serviços
              </span>
              <h2 className="sec-title style2">Soluções completas e customizadas para a gestão de talentos da sua empresa.</h2>
            </div>
          </div>
          <div className="col-lg-7">
  <div className="service-title-area">
    <p className="">
      Oferecemos um ecossistema completo de RH para otimizar processos seletivos e garantir a escalabilidade da sua operação. Atuamos de forma consultiva e contamos com uma plataforma própria, onde acompanhamos toda a esteira de triagem — incluindo a gestão documental dos candidatos —, otimizando o tempo no processo de contratação e garantindo o profissional certo para cada vaga.
    </p>
  </div>
</div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row gx-30 global-carousel service-slider2">
          <Slider {...settings}>
            <div className="p-3">
              <div className="service-box">
                <div className="service-box_content">
                  <div className="service-box_icon">
                    <img src="assets/img/home/4/1.png" alt="Recrutamento e Seleção" />
                  </div>
                  <h4 className="service-box_title h5">
                    <Link to="/servicos">Recrutamento e Seleção Estratégica</Link>
                  </h4>
                  <p className="service-box_text">
                    Processo completo de atração, triagem e seleção de profissionais alinhados à cultura e aos objetivos da sua empresa, aumentando a assertividade nas admissões.
                  </p>
                  <Link
                    to="/servicos"
                    className="global-btn style-border"
                  >
                    Saber Mais{" "}
                    <img src="assets/img/icon/right-icon2.svg" alt="Seta Direita Rocvel" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="p-3">
              <div className="service-box">
                <div className="service-box_content">
                  <div className="service-box_icon">
                    <img src="assets/img/home/4/1.png" alt="Hunting Especializado" />
                  </div>
                  <h4 className="service-box_title h5">
                    <Link to="/servicos">Hunting de Profissionais Especializados</Link>
                  </h4>
                  <p className="service-box_text">
                    Busca ativa e focada de talentos estratégicos para posições técnicas, comerciais, administrativas e de alta liderança que são de difícil acesso no mercado.
                  </p>
                  <Link
                    to="/servicos"
                    className="global-btn style-border"
                  >
                    Saber Mais
                    <img src="assets/img/icon/right-icon2.svg" alt="Seta Direita Rocvel" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="p-3">
              <div className="service-box">
                <div className="service-box_content">
                  <div className="service-box_icon">
                    <img src="assets/img/home/4/2.png" alt="Estruturação de Equipes" />
                  </div>
                  <h4 className="service-box_title h5">
                    <Link to="/servicos">Estruturação de Equipes</Link>
                  </h4>
                  <p className="service-box_text">
                    Desenvolvimento, montagem e expansão rápida de equipes operacionais e corporativas para empresas em fase de expansão acelerada, redes e franquias.
                  </p>
                  <Link
                    to="/servicos"
                    className="global-btn style-border"
                  >
                    Saber Mais
                    <img src="assets/img/icon/right-icon2.svg" alt="Seta Direita Rocvel" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="p-3">
              <div className="service-box">
                <div className="service-box_content">
                  <div className="service-box_icon">
                    <img src="assets/img/home/4/3.png" alt="RPO Terceirização" />
                  </div>
                  <h4 className="service-box_title h5">
                    <Link to="/servicos">RPO (Recruitment Process Outsourcing)</Link>
                  </h4>
                  <p className="service-box_text">
                    Terceirização parcial ou integral dos seus processos de recrutamento, proporcionando mais eficiência operacional e drástica redução de custos internos.
                  </p>
                  <Link
                    to="/servicos"
                    className="global-btn style-border"
                  >
                    Saber Mais
                    <img src="assets/img/icon/right-icon2.svg" alt="Seta Direita Rocvel" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="p-3">
              <div className="service-box">
                <div className="service-box_content">
                  <div className="service-box_icon">
                    <img src="assets/img/home/4/4.png" alt="Consultoria em RH" />
                  </div>
                  <h4 className="service-box_title h5">
                    <Link to="/servicos">Consultoria em RH e Gestão de Talentos</Link>
                  </h4>
                  <p className="service-box_text">
                    Soluções voltadas à organização de processos seletivos, mapeamento de perfil profissional, desenvolvimento organizacional e gestão de performance.
                  </p>
                  <Link
                    to="/servicos"
                    className="global-btn style-border"
                  >
                    Saber Mais
                    <img src="assets/img/icon/right-icon2.svg" alt="Seta Direita Rocvel" />
                  </Link>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default ServiceThree;